import React from "react";
import "../../styles/ContactHeroSection.css"; // Reuse existing CSS for hero and buttons

const HighRoofVanHero = () => {
  return (
    <section className=" highroof-van py-5">
      <div className="overlay"></div>

      <div className="container hero-content">
        <div className="text-wrapper text-center">

          {/* Section Heading */}
          <h1>
            Affordable High Roof Cargo Van Rental Company in Dubai
          </h1>

          {/* Section Paragraphs */}
          <p>
            Looking for an affordable high-roof van hire in Dubai? Our well-maintained high-roof cargo vans are designed for businesses that need extra vertical space, easy loading, and reliable city transport. These vans are ideal for furniture movement, event equipment, retail stock, and bulk deliveries where space matters more than temperature control. Each vehicle is serviced regularly to ensure smooth, cost-effective operations.
          </p>

          <p>
            For goods requiring moderate cooling, selected high-roof models are available with a chiller van rental option. When deep freezing is essential, a freezer van is also available for rent, allowing businesses to switch between non-refrigerated and temperature-controlled transport as needed.
          </p>

          <p>
            <a href="tel:+971544792905">Call</a> or <a href="https://wa.me/971544792905">Whatsapp Now</a> to book a high-roof van or get expert rental guidance.
          </p>

          {/* CTA Buttons */}
          <div className="hero-buttons mt-4">
            <a href="#contact-form" className="btn btn-primary me-2">
              Request a Quote
            </a>
            <a href="tel:+971544792905" className="btn btn-primary inverse">
              Call Now
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HighRoofVanHero;

